import React, { useRef, useState } from 'react';
import { Tooltip } from '@checkout/react-components';
import { logger } from '@/lib/logger';

import { InfoIconButton, TooltipStyleOverrides } from './StyledComponents';
import { QuestionIcon } from '@/components/Common/Icons';
import { Link, Paragraph } from '../../Common';
import { getContent, getLocale } from '@/lib';
const TINTooltip = () => {
  const [isTooltipDisplayed, setIsTooltipDisplayed] = useState(false);
  const infoButtonRef = useRef(null);

  const tooltipAriaLabel = getContent('crs.oecdTinGuidance');

  const tooltipClickHandler = () => {
    setIsTooltipDisplayed(false);
    infoButtonRef.current?.focus();
  };

  const infoButtonClickHandler = () => {
    setIsTooltipDisplayed(!isTooltipDisplayed);
  };

  const logFPTIEvent = () => {
    logger.fpti('crs_tin_tooltip_link_click', {
      onboard_country: getLocale().country,
      state_name: 'crs_section',
      transition_name: 'process_tin_tooltip_link_click',
    });
    logger.info('crs_tin_tooltip_link_clicked');
  };

  const oecdLink = (
    <Link
      href="https://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers/"
      text={getContent('crs.oecdTinGuidance')}
      testId="tin-oecd-link"
      onClick={logFPTIEvent}
    />
  );

  return (
    <>
      <InfoIconButton
        data-testid="tin-info-icon"
        ref={infoButtonRef}
        id="tin-info-icon"
        type="button"
        aria-label={tooltipAriaLabel}
        aria-describedby="tin-info-tooltip"
        onClick={infoButtonClickHandler}
      >
        <QuestionIcon width={24} height={24} />
      </InfoIconButton>
      {isTooltipDisplayed && (
        <Tooltip
          arrowPosition="top"
          id="tin-tooltip"
          onClick={tooltipClickHandler}
          styleOverrides={TooltipStyleOverrides}
        >
          <div id="tin-info-tooltip">
            <Paragraph fontSize="16px" fontWeight="400" padding="5px">
              {getContent('crs.tin.toolTip', { oecdTinGuidance: oecdLink })}
            </Paragraph>
          </div>
        </Tooltip>
      )}
    </>
  );
};

export { TINTooltip };
